import { s as __toESM } from "./rolldown-runtime-Bg48TavK.es.js";
import { t as require_jszip_min } from "./jszip-C49i9kUs.es.js";
var import_jszip_min = /* @__PURE__ */ __toESM(require_jszip_min(), 1);
async function createZip(blobs, fileNames) {
	const zip = new import_jszip_min.default();
	blobs.forEach((blob, index) => {
		zip.file(fileNames[index], blob);
	});
	return await zip.generateAsync({
		type: "blob",
		compression: "DEFLATE"
	});
}
export { createZip as t };
